import Glide from '@glidejs/glide';

let glide = new Glide('.glide', {
  type: 'carousel',
  perView: 1,
  focusAt: 'center',
  autoplay: 6000,
});
glide.mount();

